export default __webpack_public_path__ + "static/media/classy.c0d59766.png";